import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupplementaryEquipmentVisitComponent } from './component/supplementary-equipment/component/supplementary-equipment.component';
import { PersonalVisitDetailsDialogComponent} from './component/personal-visit-details-dialog/personal-visit-details-dialog.component';
import { PersonalVisitSearchComponent} from './personal-visit-search/personal-visit-search.component';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule, ServiceResponseModule } from '@sdbn/appclient';
import { VisitMasterdataComponent } from './component/visit-masterdata/visit-masterdata.component';
import { VisitVisitedComponent } from './component/visit-visited/visit-visited.component';
import { VisitGroupComponent } from './component/visit-group/visit-group.component';
import { TMCTableModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';
import { VisitLogComponent } from './component/visit-log/visit-log.component';
import { VisitTasksComponent } from './component/visit-tasks/visit-tasks.component';

@NgModule({
  declarations: [
    PersonalVisitDetailsDialogComponent,
    PersonalVisitSearchComponent,
    SupplementaryEquipmentVisitComponent,
    VisitMasterdataComponent,
    VisitVisitedComponent,
    VisitGroupComponent,
    VisitLogComponent,
    VisitTasksComponent
  ],
  imports: [
    RouterModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    CommonTranslationModule,
    TMCTableModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
        ServiceResponseModule
  ]
})
export class PersonalVisitModule { }
